import { breakpoints, fontSize, fontWeight, letterSpacing, lineHeight } from './tokens';

// next/font hashes the real family name, so it can only be reached through the CSS variable that
// `notoSans.variable` declares on <html> in src/app/layout.tsx (loader: src/fonts/notoSans.ts).
const fontFamily = 'var(--font-noto-sans), Helvetica, Arial, sans-serif';

export const typography = {
    fontFamily: fontFamily,
    fontSize: 16,

    // Label 1
    label1regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[10],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label1medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[10],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label1semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[10],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label1bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[10],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Label 2
    label2regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[12],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label2medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[12],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label2semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[12],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label2bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[12],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Label 3
    label3regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[13],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label3medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[13],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label3semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[13],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label3bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[13],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Label 4
    label4regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[14],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label4medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[14],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label4semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[14],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label4bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[14],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Label 5
    label5regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[15],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label5medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[15],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label5semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[15],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label5bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[15],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Label 6
    label6regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[16],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label6medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[16],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label6semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[16],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    label6bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[16],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Paragraph 1
    paragraph1regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[12],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph1medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[12],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph1semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[12],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph1bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[12],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },

    // Paragraph 2
    paragraph2regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[13],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph2medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[13],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph2semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[13],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph2bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[13],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },

    // Paragraph 3
    paragraph3regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[14],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph3medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[14],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph3semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[14],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph3bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[14],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },

    // Paragraph 4
    paragraph4regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[15],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph4medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[15],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph4semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[15],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph4bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[15],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },

    // Paragraph 5
    paragraph5regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[16],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph5medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[16],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph5semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[16],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },
    paragraph5bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[16],
        lineHeight: lineHeight[150],
        letterSpacing: 0,
    },

    // Heading 1
    heading1regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[18],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    heading1medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[18],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    heading1semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[18],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },
    heading1bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[18],
        lineHeight: lineHeight[130],
        letterSpacing: 0,
    },

    // Heading 2
    heading2regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[20],
        lineHeight: lineHeight[125],
        letterSpacing: 0,
    },
    heading2medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[20],
        lineHeight: lineHeight[125],
        letterSpacing: 0,
    },
    heading2semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[20],
        lineHeight: lineHeight[125],
        letterSpacing: 0,
    },
    heading2bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[20],
        lineHeight: lineHeight[125],
        letterSpacing: 0,
    },

    // Heading 3
    heading3regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[24],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative025,
    },
    heading3medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[24],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative025,
    },
    heading3semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[24],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative025,
    },
    heading3bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[24],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative025,
    },

    // Heading 4
    heading4regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[28],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative05,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[26],
            letterSpacing: letterSpacing.negative025,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[24],
        },
    },
    heading4medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[28],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative05,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[26],
            letterSpacing: letterSpacing.negative025,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[24],
        },
    },
    heading4semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[28],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative05,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[26],
            letterSpacing: letterSpacing.negative025,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[24],
        },
    },
    heading4bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[28],
        lineHeight: lineHeight[120],
        letterSpacing: letterSpacing.negative05,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[26],
            letterSpacing: letterSpacing.negative025,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[24],
        },
    },

    // Heading 5
    heading5regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[36],
        lineHeight: lineHeight[115],
        letterSpacing: letterSpacing.negative075,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[32],
            letterSpacing: letterSpacing.negative05,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[28],
            lineHeight: lineHeight[120],
        },
    },
    heading5medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[36],
        lineHeight: lineHeight[115],
        letterSpacing: letterSpacing.negative075,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[32],
            letterSpacing: letterSpacing.negative05,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[28],
            lineHeight: lineHeight[120],
        },
    },
    heading5semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[36],
        lineHeight: lineHeight[115],
        letterSpacing: letterSpacing.negative075,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[32],
            letterSpacing: letterSpacing.negative05,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[28],
            lineHeight: lineHeight[120],
        },
    },
    heading5bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[36],
        lineHeight: lineHeight[115],
        letterSpacing: letterSpacing.negative075,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[32],
            letterSpacing: letterSpacing.negative05,
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[28],
            lineHeight: lineHeight[120],
        },
    },

    // Heading 6
    heading6regular: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.regular,
        fontSize: fontSize[44],
        lineHeight: lineHeight[110],
        letterSpacing: letterSpacing.negative1,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[40],
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[36],
            lineHeight: lineHeight[115],
            letterSpacing: letterSpacing.negative075,
        },
    },
    heading6medium: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[44],
        lineHeight: lineHeight[110],
        letterSpacing: letterSpacing.negative1,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[40],
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[36],
            lineHeight: lineHeight[115],
            letterSpacing: letterSpacing.negative075,
        },
    },
    heading6semibold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.semiBold,
        fontSize: fontSize[44],
        lineHeight: lineHeight[110],
        letterSpacing: letterSpacing.negative1,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[40],
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[36],
            lineHeight: lineHeight[115],
            letterSpacing: letterSpacing.negative075,
        },
    },
    heading6bold: {
        fontFamily: fontFamily,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[44],
        lineHeight: lineHeight[110],
        letterSpacing: letterSpacing.negative1,
        [`@media (max-width:${breakpoints.md})`]: {
            fontSize: fontSize[40],
        },
        [`@media (max-width:${breakpoints.sm})`]: {
            fontSize: fontSize[36],
            lineHeight: lineHeight[115],
            letterSpacing: letterSpacing.negative075,
        },
    },
};
